import React from "react";
export const playbackRates = [
    { icon: React.createElement("i", { className: "icon-x1 font-h2" }), value: 1 },
    { icon: React.createElement("i", { className: "icon-x1_5 font-h2" }), value: 1.5 },
    { icon: React.createElement("i", { className: "icon-x2 font-h2" }), value: 2 }
];
export const SIZES_CLIP = {
    heightVideoClip: "350px",
    widthVideoClip: "100%"
};
